import React from 'react';
import { Button, Divider, List, Tag } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useGetDocumentLink } from 'api/documents/use-get-document-link';
import { useDownloadFile } from 'shared/hooks/use-download-file';
import { formatDateTime } from 'shared/utils/time/format-date-time.ts';
import { DocumentType } from 'types/document';
import { DocumentControl } from 'components/documents/document-item/components/document-control';
import { DocumentPreviewButton } from 'components/documents/document-item/components/document-preview-button';
import { DocumentTypeButton } from 'components/documents/document-item/components/document-type-button';
import type { IDocumentItemProps } from 'components/documents/document-item/types';

export const DocumentItem: React.FC<IDocumentItemProps> = (props) => {
  const { document, readOnly = false } = props;

  const downloadFile = useDownloadFile();
  const { mutateAsync: downloadDocument, isLoading } = useGetDocumentLink();

  const getDocumentLink = async () => {
    if (document.url) return { url: document.url };
    return downloadDocument({ documentId: document.id });
  };

  const handleClick = async () => {
    try {
      const result = await getDocumentLink();
      if (result) downloadFile(result.url);
    } catch {
      return;
    }
  };

  return (
    <List.Item
      key={document.id}
      actions={[
        readOnly ? (
          <Tag key='type'>{DocumentType[document.type]}</Tag>
        ) : (
          <DocumentTypeButton key='type' documentId={document.id} type={document.type} />
        ),
        <DocumentPreviewButton
          key={DocumentPreviewButton.name}
          name={document.name}
          documentId={document.id}
          mimeType={document.mimeType}
          getLinkForPreview={getDocumentLink}
        />,
        readOnly ? (
          <Button key='download' type='text' icon={<DownloadOutlined />} loading={isLoading} onClick={handleClick} />
        ) : (
          <DocumentControl key={DocumentControl.name} documentId={document.id} />
        ),
      ]}>
      <List.Item.Meta
        title={readOnly ? document.name : <a onClick={handleClick}>{document.name}</a>}
        description={
          <>
            <span>{formatDateTime(document.createdAt)}</span>
            <Divider type='vertical' />
            <span>{document.user?.name}</span>
          </>
        }
      />
    </List.Item>
  );
};
